export const isMobile = () => window.innerWidth < 900;
